import { Component } from '@verndale/core'

class jumpLinksGasProperties extends Component {
  setupDefaults() {
    this.dom = {
      $jumpLinks: this.el.querySelector('.jump-links'),
      $navWrapper: this.el.querySelector('.jump-links__wrapper'),
      $alphabet: this.el.dataset.alphabet
    }

    this.setObserver()
    if (this.dom.$alphabet) this.createSections()
    this.createJumpLinks()
    this.handleObserveSections()
  }

  handleObserveSections() {
    const observedSections = document.querySelectorAll('.gas-listing__sections')
    observedSections.forEach((section) => {
      this.observer.observe(section)
    })
  }

  createSections() {
    const container = document.querySelector('.gas-listing__sections-container')
    const cardsTitle = document.querySelectorAll('.gas-properties-card h3')
    const firtsLetters = Array.from(cardsTitle).map((title) => title.dataset.info.charAt(0))
    this.cleanRepeated = firtsLetters.filter((c, index) => firtsLetters.indexOf(c) === index).sort()
    this.cleanRepeated.map((section) => {
      const sectionTag = document.createElement('section')
      sectionTag.setAttribute('id', `jump-link-section-${section}`)
      sectionTag.classList.add('gas-listing__sections')
      Array.from(cardsTitle).map((title) =>
        title.dataset.info.charAt(0) === section ? sectionTag.appendChild(title.parentNode) : null
      )
      container.appendChild(sectionTag)
    })
    container.classList.add('gas-listing__sections-container--show')
  }

  setObserver() {
    const options = {
      root: null,
      treshold: 0,
      rootMargin: '-12% 0% -85%'
    }
    this.observer = new IntersectionObserver((entries) => this.handleOnIntersect(entries), options)
  }

  createJumpLinks() {
    this.dom.$jumpLinks.innerHTML = ''
    this.cloneJumpLinks = this.dom.$jumpLinks.cloneNode(true)
    if (this.dom.$alphabet) {
      this.alphabetObj = JSON.parse(this.dom.$alphabet).sort()
      this.alphabetObj.forEach((section) => {
        const disabled = this.cleanRepeated.find((x) => x === section)
        this.cloneJumpLinks.innerHTML += `<a class='jump-links__link gas-listing__item ${
          disabled ? '' : 'gas-listing__item--disable'
        } ' href="#jump-link-section-${section}">${section}</a>`
      })
    }
    this.dom.$jumpLinks.innerHTML = this.cloneJumpLinks.innerHTML
    this.navJumpLink = document.querySelectorAll('.jump-links__link')
  }

  addListeners() {
    this.dom.$jumpLinks.addEventListener('click', (e) => this.handleClick(e))
  }

  cleanActiveState() {
    this.navJumpLink.forEach((item) => item.classList.remove('gas-listing__item--scroll-active'))
  }

  handleOnIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.cleanActiveState()
        const id = `#${entry.target.id}`
        Array.from(this.navJumpLink)
          .find((x) => x.getAttribute('href') === id)
          ?.classList.add('gas-listing__item--scroll-active')
      }
    })
  }

  handleClick(e) {
    e.preventDefault()
    const jumpLinks = this.el.querySelectorAll('.jump-links__link')

    jumpLinks.forEach((link) => {
      if (link.classList.contains('gas-listing__item--active')) {
        link.classList.remove('gas-listing__item--active')
      }
    })

    e.target.classList.add('gas-listing__item--active')

    const alphabetSections = document.querySelectorAll('.gas-listing__sections')
    const id = e.target.getAttribute('href').substring(1)
    const offset = 65
    const target =
      Array.from(alphabetSections).find((x) => x.getAttribute('id') === id)?.offsetTop - offset
    window.scroll({
      top: target,
      behavior: 'smooth'
    })
  }
}

export default jumpLinksGasProperties
